// ABOUTME: Search-table cell renderer for the nodes of one hierarchy that link the row ("Linked by" columns).
// ABOUTME: Draws them like the link cells: the first as a chip, the others in a "+N" chip that opens a menu on hover.

import { type LinkedByColumnGroup, linkedByRefLabel } from '../linkedByColumns';
import { LinkChipClickHandler, LinkChipList } from './LinkChipList';

export type LinkedByNodeClickHandler = (ref: { hierarchyId: string; nodeId: string }) => void;

export function GridCellLinkedByRender({
    group,
    onNodeClick,
}: {
    group: LinkedByColumnGroup | null;
    /** opens a linking node; without it the chips are read-only */
    onNodeClick?: LinkedByNodeClickHandler;
}) {
    if (!group?.items.length) {
        return null;
    }

    const { hierarchyId, items } = group;
    const handleClick: LinkChipClickHandler | undefined = onNodeClick
        ? (e, index) => {
              e.stopPropagation();
              onNodeClick({ hierarchyId, nodeId: items[index].nodeId });
          }
        : undefined;

    // Read-only chips sit in a clickable row and inherit its pointer: the default cursor keeps them
    // from looking clickable.
    const cellStyle = handleClick
        ? { display: 'contents' }
        : { display: 'contents', cursor: 'default' };

    return (
        <span style={cellStyle}>
            <LinkChipList
                items={items.map(ref => ({ key: ref.nodeId, label: linkedByRefLabel(ref) }))}
                totalCount={group.totalCount}
                onItemClick={handleClick}
            />
        </span>
    );
}
